// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__wT4Qt"};